import React from 'react'

const Preferences = () => {
  return (
    <div>Preferences</div>
  )
}

export default Preferences